export default "__VITE_ASSET__D$R_8DUG__"